import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

import { breakpoints, darkGrey } from '~/src/styles';

export const Container = styled.div`
  background: ${darkGrey};
  width: 100%;
`;

export const ContentWrapper = styled.div`
  ${breakpoints.minDesktop} {
    display: grid;
    grid-template-areas: 'description hero' 'meta-info meta-info';
    gap: 36px;
    padding: 60px 60px 30px;
    grid-template-columns: 1fr 1fr;
    max-width: 1200px;
    margin: auto;
  }
`;
const Block = styled.div`
  padding-left: 18px;
  padding-right: 18px;
  ${breakpoints.minTablet} {
    width: 640px;
    padding-left: 0px;
    padding-right: 0px;
    margin: auto;
  }

  ${breakpoints.minDesktop} {
    width: unset;
  }
`;
export const HeroBlock = styled.div`
  grid-area: hero;
  ${breakpoints.minTablet} {
    width: 640px;
    margin: auto;
  }

  ${breakpoints.minDesktop} {
    width: unset;
  }
`;

export const MetaInfoBlock = styled(Block)`
  grid-area: meta-info;

  padding-top: 18px;
  ${breakpoints.minDesktop} {
    padding: 0;
  }
`;

export const DescriptionBlock = styled(Block)`
  grid-area: 'description';
  padding-bottom: 36px;
`;

export const DividerBlockContainer = styled(Block)`
  padding-top: 20px;
  padding-bottom: 20px;
  ${breakpoints.minDesktop} {
    display: none;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 0.5px;
  background-color: #636363;
  ${breakpoints.minTablet} {
    width: 640px;
    margin: auto;
  }
`;

const DividerBlock: React.FC = () => {
  return (
    <DividerBlockContainer>
      <Divider />
    </DividerBlockContainer>
  );
};

export const DetailsContainer: React.FC<PropsWithChildren> & {
  HeroBlock: React.FC<PropsWithChildren>;
  MetaInfoBlock: React.FC<PropsWithChildren>;
  DividerBlock: React.FC<PropsWithChildren>;
  DescriptionBlock: React.FC<PropsWithChildren>;
} = ({ children }) => {
  return (
    <Container>
      <ContentWrapper>{children}</ContentWrapper>
    </Container>
  );
};

DetailsContainer.HeroBlock = HeroBlock;
DetailsContainer.MetaInfoBlock = MetaInfoBlock;
DetailsContainer.DividerBlock = DividerBlock;
DetailsContainer.DescriptionBlock = DescriptionBlock;
